import { render, staticRenderFns } from "./Collapse.component.vue?vue&type=template&id=a83fed7c"
import script from "./Collapse.component.vue?vue&type=script&lang=js"
export * from "./Collapse.component.vue?vue&type=script&lang=js"
import style0 from "./Collapse.component.vue?vue&type=style&index=0&id=a83fed7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports